import React, { useState, useEffect } from 'react';
import { BrowserRouter , Route, Switch, Redirect } from 'react-router-dom';
import {Main,Axios,Loading,Swal} from './Helpers/importacionesComunes'
import './App.css';
import Alertas from './componentes/Alertas';
import Personal from './Vistas/Regiones';
import MesesDiezmados from './reportes/MesesDiezmados';
import HistorialAportes from './reportes/HistorialAportes';
import Iglesias from './Vistas/iglesias/vista/Iglesias';
import ReportesSP from './Vistas/ReportesSP';
import Ministros from './Vistas/ministros/vista/Ministros';
import Usuarios from './Vistas/usuarios/vista/Usuarios';
import Interdepositos from './Vistas/interdepositos/vista/Interdepositos';
import DepositosSinIdentificar from './Vistas/depositosSinIdentificar/vista/Interdepositos';
import CrearInterdepositos from './Vistas/interdepositos/vista/crear';
import RubroEgresos from './Vistas/rubroEgresos/vista/lista';
import RubroIngresos from './Vistas/rubroIngresos/vista/lista';
import FondosTesoreria from './Vistas/fondosTesoreria/vista/lista';
import DestinoIngresos from './Vistas/destinoIngresos/vista/lista';
import Ingresos from './Vistas/ingresos/vista';
import IngresosTesoreria from './Vistas/ingresos-tesoreria/vista';
import Estadisticas from './componentes/Estadisticas';
import {Tramites} from './Vistas/tramites/vistas/Tramites';
import {TramitesNew} from './Vistas/tramites/vistas/TramitesNew';
import Logs from './componentes/Logs';
import Documentos from './componentes/Documentos';
import ReportesEgIntegrales from './Vistas/ReportesEgIntegrales';
import ReportesGrupo from './Vistas/ReportesGrupo';
import Emails from './Vistas/Emails';
import Login from './Vistas/Login';
import {ContextProviderGlobal, useContextoGlobal } from './Context/contextoGlobal'; // importo proveedor de contexto y luego envuelvo a la aplicación en el mismo
import {setToken, deleteToken, getToken, initAxiosInterceptors} from './Helpers/auth-helpers'
import {fechaActual,compararFechas} from './Helpers/fechas';
import socketIOClient from "socket.io-client";
import Home from './Vistas/Home'
import Codigos from './Vistas/Codigos';
import Status from './Vistas/Status';
import ReportesIngIntegrales from './Vistas/ReportesIngIntegrales';
import {Reporte as ReporteEspecial} from './reportesEspeciales/pages/Reporte'
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import {CustomSnackBar} from './componentes/MUI/CustomSnackBar'
import { MenuSidebar } from './componentes/sidebar';
import { MenuAppBar } from './componentes/MUI/MenuAppBar';
import { Spinner } from '@material-tailwind/react';
import { MenuDrawer } from './componentes/Drawer';
import Asambleas from './componentes/Asambleas';
import { Evento } from './Vistas/eventos/vistas/Evento';
import { Cupones } from './Vistas/cupones/vistas/Cupones';
import Ejemplo from './componentes/Ejemplo';
import ResetPassword from './componentes/reset-password';
import Nacionalidades from './Vistas/Nacionalidades';
import Regiones from './Vistas/RegionesViewList';
import Rangos from './Vistas/Rangos';
import Provincias from './Vistas/Provincias';
import Partidos from './Vistas/Partidos';
import Bancos from './Vistas/Bancos';
import CajaRubros from './Vistas/CajaRubros';
import LibrosFET from './Vistas/LibrosFET';
import Proveedores from './Vistas/Proveedores';
import EnvioEmails from './Vistas/GenerarEmails';
import Tandas from './Vistas/Tandas';
import TipoComprobante from './Vistas/TiposComprobante';
import ReportesIngresosIntegrales from './Vistas/ReporteIngresosIntegrales';
import Distritos from './Vistas/Distritos';
import EstadosCiviles from './Vistas/EstadosCiviles';
import TipoIglesias from './Vistas/TipoIglesias';
import TipoDocumentos from './Vistas/TipoDocumentos';
import TipoCuentasBanco from './Vistas/TipoCuentasBanco';
import CajasUad from './Vistas/CajasUad';
import CuentasBancariasUAD from './Vistas/CuentasBancariasUAD';
import ParametrosSistema from './Vistas/ParametrosSistema';
import PreguntasFrecuentes from './Vistas/eventos/componentes/PreguntasFrecuentes'
import Egresos from './Vistas/egresos/vista';
import CrearEgreso from './Vistas/egresos/vista/Crear';
import DetalleEgreso from './Vistas/egresos/vista/Detalle';
import DetalleIngreso from './Vistas/ingresos-tesoreria/vista/detalle';
import CreaEditarIngreso from './Vistas/ingresos-tesoreria/vista/crearEditar';
import {MailsEnviados} from './Vistas/eventos/componentes/MailsEnviados';
import ReporteObrerosAportes from './Vistas/ReporteObrerosAportes';
import EditarEgreso from './Vistas/egresos/vista/Editar';
import IglesiaDelegados from './componentes/IglesiaDelegados';

// const client_graphql = new ApolloClient({
//   uri: process.env.REACT_APP_API_GRAPHQL,
//   cache: new InMemoryCache()
// });

// propType es un tipo genérico (id, nombre) usado como DTO en muchos contextos distintos
// (ministro, distrito, etc). No representa una entidad única del dominio.
// Desactivamos la normalización para evitar colisiones de cache en Apollo
// cuando distintos objetos comparten el mismo id pero significan cosas diferentes. Antes InMemoryCache tenía un objeto vacío ahora hay una configuración de typePolicies
// Como cacheaba el propType con un id, como puede significar muchas cosas ministro, region, distrito...etc quedaba grabado algo que no era.

const client_graphql = new ApolloClient({ uri: process.env.REACT_APP_API_GRAPHQL, cache: 
  new InMemoryCache({ typePolicies: { propType: { keyFields: false } } }) 
});

// variables para monitoreo de actividad
let tiempo_en_segundos_inactividad = 2400;
let contador; 
let id_intervalo_monitoreo;
let id_intervalo_contador;
let id_tiempo_reinicio;

initAxiosInterceptors(); // esto se llama apenas se ejecute el archivo principal antes de 
                         // cargar la función app para que se active el proceso de analizar
                          // cada request de entrada para ver si hay un error de autorización
                          // y cada request de salida para añadirle el token si es que existe
                          // se añade al header para que el servidor lo reciba en el request y
                          // lo autorice para las rutas protegidas
function App() {

  const [usuario,setUsuario] = useState(null) // es estado inicial del usuario es null o sea no hay usuario
  const [cargandoUsuario,setCargandoUsuario]=useState(true);
  const [cargandoCuatrimestre,setCargandoCuatrimestre]=useState(false);
  const [error,setError] = useState(null);
  const [hora,setHora] = useState(null);
  const [reinicioLogin,setReinicioLogin]=useState(0)
  const [esuncelular,setesuncelular]=useState(false)
  const {setFiltrosMinistros,setFiltrosIglesias,
        setearUsuario,
        celularSino,
        exponerConexionWebSocket,
        contadorOperacionesGlobales,isIOSWebView} = useContextoGlobal();

  useEffect(()=>{
    if(document.documentElement.clientWidth < 482){
      setesuncelular(true)
      celularSino(true)
    }else{
      setesuncelular(false)
      celularSino(false)
    }
    
  },[])

  useEffect(()=>{

    async function cargarUsuario(){

        if(!getToken()){
            setCargandoUsuario(false);
            setCargandoCuatrimestre(false); // si no hay token debe re loguearse
            return;
        }else{
            try{
                const { data } = await Axios.get('/api/usuarios/whoami');
                setUsuario(data.usuario);
                setearUsuario(data.usuario); // para exponerlo en el context
                setCargandoUsuario(false);
            }catch(error){
                console.log(error)
            }
        }
    }

    cargarUsuario();
    confirmarTiempoInactividadAceptado()
    exponerConexionWebSocket(conectarWebSocket())
  },[]); // el segundo parametro [] se pasa para que se ejecute 1 sola vez 


  useEffect(()=>{

   if (usuario){
      activarMonitoreoActividad(setReinicioLogin) // cada vez que se loguea el usuario o se refresca la vista se
                                                  // se activa el monitoreo de la actividad para detectar 
                                                  // tiempos de inactividad y si fuese necesario pedir al usuario 
                                                  // que confirme que sigue conectado
    }
 
  },[usuario,contadorOperacionesGlobales])

  function logout(){
      setUsuario(null);
      setearUsuario(null); // para exponerlo en el context
      setFiltrosMinistros({});
      setFiltrosIglesias({});
      deleteToken();
  }

  function reiniciarLogin(){
    window.location.reload()
  }

  function activarMonitoreoActividad(setReinicioLogin){
    // cada vez que se inicia el monitoreo de actividad se limpian los flags para 
    // asegurarnos que se reinicie el proceso
    sessionStorage.removeItem('haction')
    sessionStorage.removeItem('checking')

    // se repite el control de actividad cada 5 segundos
    // pasamos la función setReinicioLogin por si es necesario forzar el renderizado de la vista
    // cambiando el estado en el caso de que se haya detectado un tiempo X de inactividad
    id_intervalo_monitoreo = setInterval(() => {
          verificarTiempo(reiniciarLogin)        
    }, 5000);
  }

  function mostrarError(error){
      setError(error)
  };

// async function login(username,password){
//   try{
//     const { data } = await Axios.post( // le digo que espere a que Axios se ejecute
//       'api/usuarios/login',{username,password});
//       setUsuario(data.usuario);
//       setearUsuario(data.usuario); // para exponerlo en el context
//       setToken(data.token)
//       setError(null)
//   }catch(err){

//     procesarRespuesta(setError,err)

// }
 
// }

async function login(username,password,captchaToken){
  try{
      const { data } = await Axios.post( // le digo que espere a que Axios se ejecute
        'api/usuarios/login/secure',{username,password,captchaToken});
        setUsuario(data.usuario);
        setearUsuario(data.usuario); // para exponerlo en el context
        setToken(data.token)
        setError(null)
    }catch(err){

    let mensaje = 'No es posible conectar con el servidor.';

    if (err.response?.data) {
      const { code, message } = err.response.data;

      switch (code) {
        case 'INVALID_CREDENTIALS':
          mensaje = 'Los datos ingresados no son correctos. Por favor verifique su usuario y contraseña.';
          break;
        case 'RATE_LIMIT_EXCEEDED':
          mensaje = 'Demasiados intentos. Por favor, espere unos minutos y vuelva a intentarlo.';
          break;
        case 'CAPTCHA_INVALIDO':
          mensaje = 'La validación de seguridad falló. Por favor intente nuevamente.';
          break;
        default:
          mensaje = message || 'Error al intentar ingresar.';
      }
    } 

    setError(mensaje);
    throw new Error(mensaje) // para que lo tome el catch de login.jsç
  }
 }

  if (cargandoUsuario){
    return  <Main center alinear>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                    <Spinner className="h-12 w-12" />
                    <span className="cargando font-semibold text-[15px]">Cargando registros...</span>
                </div>
            </Main>
  };

  
  if (cargandoCuatrimestre){
    return  <Main center alinear>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                    <Spinner className="h-12 w-12" />
                    <span className="cargando font-semibold text-[15px]">Cargando registros...</span>
                </div>
            </Main>
  };

   return (
    <BrowserRouter>
      <div className="Main center" onMouseUp={monitorearClicks}>
        { usuario ? 
        <>
          <div className='w-full flex flex-col'>
            <div className='flex flex-col lg:flex-row'>
              <div className='w-full flex lg:hidden'>
                <MenuAppBar usuario={usuario} />
              </div>
              
              <MenuSidebar usuario={usuario} logout={logout} />

              <div className='w-full content-normal flex flex-row min-h-[calc(100vh)]'>
                <MenuDrawer usuario={usuario} logout={logout}/>
                <Main>
                  <div className='w-full hidden lg:flex'>
                    <MenuAppBar usuario={usuario} className="w-full"/>
                  </div>
                  <div className={esuncelular ? "flex flex-row mt-6" : "flex flex-row mt-10 justify-center"}>
                    <LoginRoutes mostrarError={mostrarError} usuario={usuario} logout={logout} />
                    <Redirect to={usuario.rol_sede === 2 ? '/asambleas' : esuncelular || (usuario.rol_sede == undefined || usuario.rol_sede < 50 || usuario.perfil == 'distrito') ? '/ministros' : usuario.sede_admin ? '/ministros' : '/ministros'} />
                  </div>
                </Main>
              </div>
            </div>
          </div>
          </>             
              : 
          <div className="Main center">
            <LogoutRoutes login={login} mostrarError={mostrarError} error={error}/>
            <Redirect to="/login" login={login}/> 
          </div>
        }
      </div>
    </BrowserRouter>
  );
}

// export default App;
// envuelvo a la aplicación con un proveedor de contexto para que la usen los componentes
// hijos.
export default ()=> 
<ApolloProvider client={client_graphql}>
  <ContextProviderGlobal>  
      <CustomSnackBar/>
      <App></App>
  </ContextProviderGlobal>
</ApolloProvider>

function LoginRoutes({mostrarError, logout, usuario}){
  return (
    <Switch>

{/*       <Route exact path="/cursos" logout={logout} component={()=><Cursos/>} />
          <Route exact path="/" logout={logout} component={()=><Cursos/>} default /> 
      Reescribí las rutas de la vista cursos reemplazando component por render
      para evitar que se renderice cada vez que cambia el componente buscarAlumnos al
      cambiar su estado. Si lo dejaba como component se renderizaba también el componente Cursos
  */
}         
<Route exact path="/administracion/:vista" render={props => (<Personal {...props}/>)}/>  
<Route exact path="/alertas" render={props => (<Alertas {...props} usuario={usuario}/>)}/>  
<Route exact path="/iglesias" render={props => (<Iglesias {...props}/>)}/>
<Route exact path="/reportes-sp" render={props => (<ReportesSP {...props} usuario={usuario}/>)}/>
<Route exact path="/ministros" render={props => (<Ministros {...props}/>)}/>
<Route exact path="/usuarios" render={props => (<Usuarios {...props}/>)}/>  
<Route exact path="/interdepositos" render={props => (<Interdepositos {...props}/>)}/> 
<Route exact path="/depositos-sin-identificar" render={props => (<DepositosSinIdentificar {...props}/>)}/>   
<Route exact path="/crear-interdepositos" render={props => (<CrearInterdepositos {...props}/>)}/> 
<Route exact path="/rubro-egresos" render={props => (<RubroEgresos {...props}/>)}/> 
<Route exact path="/rubro-ingresos" render={props => (<RubroIngresos {...props}/>)}/>
<Route exact path="/fondos-tesoreria" render={props => (<FondosTesoreria {...props}/>)}/>
<Route exact path="/destino-ingresos" render={props => (<DestinoIngresos {...props}/>)}/> 
<Route exact path="/ingresos-r" render={props => (<Ingresos {...props}/>)}/>
<Route exact path="/ingresos-t" render={props => (<IngresosTesoreria {...props} usuario={usuario}/>)}/>
<Route exact path="/egresos" render={props => (<Egresos {...props}/>)}/>
<Route exact path="/egresos/crear" render={props => (<CrearEgreso {...props}/>)}/> 
<Route exact path="/egreso/detalle" render={props => (<DetalleEgreso {...props}/>)}/>
<Route exact path="/ingreso/detalle" render={props => (<DetalleIngreso {...props}/>)}/> 
<Route exact path="/ingreso/crear-e" render={props => (<CreaEditarIngreso {...props}/>)}/>
<Route exact path="/egreso/editar" render={props => (<EditarEgreso {...props}/>)}/> 
<Route exact path="/logs" render={props => (<Logs {...props}/>)}/> 
<Route exact path="/documentos" render={props => (<Documentos {...props} usuario={usuario}/>)}/>  
<Route exact path="/emails" render={props => (<Emails {...props}/>)}/>  
<Route exact path="/reportes-ei" render={props => (<ReportesEgIntegrales {...props}/>)}/>  
<Route exact path="/reportes-obap" render={props => (<ReporteObrerosAportes {...props}/>)}/>  
<Route exact path="/reportes-ii" render={props => (<ReportesIngresosIntegrales {...props}/>)}/> 
<Route exact path="/reportes-ii-2" render={props => (<ReportesIngIntegrales {...props}/>)}/>   
<Route exact path="/reportes-re" render={props => (<ReporteEspecial {...props}/>)}/>  
<Route exact path="/reportesg" render={props => (<ReportesGrupo {...props}/>)}/>  
<Route exact path="/estadisticas" render={props => (<Estadisticas {...props} usuario={usuario}/>)}/>  
<Route exact path="/tramites" render={props => (<Tramites {...props} usuario={usuario}/>)}/>  
<Route exact path="/tramites-new/:version" render={props => (<TramitesNew {...props} usuario={usuario}/>)}/>  
<Route exact path="/reporte-md" render={props => (<MesesDiezmados {...props} usuario={usuario}/>)}/>  
<Route exact path="/reporte-ha" render={props => (<HistorialAportes {...props} usuario={usuario}/>)}/>  
<Route default exact path="/home" render={props => (<Home{...props} usuario={usuario} logout={logout}/>)}/>  
<Route exact path="/asambleas" render={props => (<Asambleas {...props} usuario={usuario} tipo="asamblea"/>)}/>  
<Route exact path="/eventos" render={props => (<Evento {...props} usuario={usuario} tipo="convencion"/>)}/>  
<Route exact path="/cupones" render={props => (<Cupones {...props} usuario={usuario} tipo="cupones"/>)}/>  
<Route exact path="/codigos/:dispositivo" render={props => (<Codigos {...props} usuario={usuario}/>)}/>  
<Route exact path="/status/:dispositivo" render={props => (<Status {...props} usuario={usuario}/>)}/>  
<Route exact path="/ejemplo" render={props => (<Ejemplo {...props} tipo="ejemplo"/>)}/> 
<Route exact path="/reset-passwords" render={props => (<ResetPassword {...props} usuario={usuario} />)}/> 
<Route exact path="/nacionalidades" render={props => (<Nacionalidades {...props} usuario={usuario} />)}/> 
<Route exact path="/regiones" render={props => (<Regiones {...props} usuario={usuario} />)}/> 
<Route exact path="/rangos" render={props => (<Rangos {...props} usuario={usuario} />)}/> 
<Route exact path="/provincias" render={props => (<Provincias {...props} usuario={usuario} />)}/> 
<Route exact path="/distritos" render={props => (<Distritos {...props} usuario={usuario} />)}/> 
<Route exact path="/estados-civiles" render={props => (<EstadosCiviles {...props} usuario={usuario} />)}/> 
<Route exact path="/tipo-iglesias" render={props => (<TipoIglesias {...props} usuario={usuario} />)}/> 
<Route exact path="/tipo-documentos" render={props => (<TipoDocumentos {...props} usuario={usuario} />)}/>
<Route exact path="/tipo-cuentas-banco" render={props => (<TipoCuentasBanco {...props} usuario={usuario} />)}/>  
<Route exact path="/cajas-uad" render={props => (<CajasUad {...props} usuario={usuario} />)}/> 
<Route exact path="/cuentas-bancarias-uad" render={props => (<CuentasBancariasUAD {...props} usuario={usuario} />)}/> 
<Route exact path="/parametros-sistema" render={props => (<ParametrosSistema {...props} usuario={usuario} />)}/> 
<Route exact path="/partidos" render={props => (<Partidos {...props} usuario={usuario} />)}/> 
<Route exact path="/bancos" render={props => (<Bancos {...props} usuario={usuario} />)}/> 
<Route exact path="/cajas-rubros" render={props => (<CajaRubros {...props} usuario={usuario} />)}/> 
<Route exact path="/proveedores" render={props => (<Proveedores {...props} usuario={usuario} />)}/> 
<Route exact path="/envio-emails" render={props => (<EnvioEmails {...props} usuario={usuario} />)}/> 
<Route exact path="/sistemas" render={props => (<MailsEnviados {...props} usuario={usuario} />)}/> 
<Route exact path="/tandas" render={props => (<Tandas {...props} usuario={usuario} />)}/> 
<Route exact path="/pfrecuentes" render={props => (<PreguntasFrecuentes {...props} usuario={usuario} />)}/> 
<Route exact path="/tipo-comprobante-egresos" render={props => (<TipoComprobante {...props} usuario={usuario} />)}/> 
<Route exact path="/libros-fet" render={props => (<LibrosFET {...props} usuario={usuario} />)}/> 
<Route exact path="/delegados" render={props => (<IglesiaDelegados {...props} usuario={usuario} />)}/> 

  </Switch>
  )
}

function LogoutRoutes({login, mostrarError, error,isIOSWebView}){
  return (
    <Switch>
        <Route  exact path="/" 
                render={props =><Login {...props} 
                login={login} mostrarError={mostrarError} error={error} isIOSWebView={isIOSWebView}/>} default/>
        <Route  path="/login" 
                render={props =><Login {...props} 
                login={login} mostrarError={mostrarError} error={error} isIOSWebView={isIOSWebView}/>} default/>                
  </Switch>
  )
}

function monitorearClicks(){ // la función monitorearClicks se dispara cada vez que el usuario hace click y guarda la fecha hora minuto y segundo para que se pueda calcular el tiempo de inactividad
    sessionStorage.setItem('haction',fechaMouse()) // la hora de ultimo click se guarda en memoria y se consulta cada X segundos para comparar y calcular los tiempos
   // clearTimeout(id_tiempo_reinicio)
}

function fechaMouse(){
    return `${fechaActual()}` // cada vez que el usuario hace click se guarda la fecha hora minuto y segundo 
                              // la función fechaActual esta en un archivo Helpers/fechas.js y usa moment.js para crear la fecha
}

function verificarTiempo(setReinicioLogin){  //esta función se ejecuta cada x segundos con un setInterval para verificar la diferencia entre la hora actual y la última hora de actividad
    const ultimoRegistro = sessionStorage.getItem('haction') // en 'haction' se va guardando la hora en que el usuario hace un click en cualquier lado como evidencia de actividad
    const checking = sessionStorage.getItem('checking') // 'checking' se usa como flag para saber si ya se mostró el mensaje preguntando al usuario si sigue conectado
    let diferencia = 0; // la variable diferencia la usamos para calcular el tiempo que pasó entre la última hora de actividad y la hora actual 
    let numero_al_azar = Math.floor(Math.random() * 100); // numero_al_azar lo usamos para forzar el renderizado de la vista, para ello modificamos esa propiedad del estado cambiando su valor al azar (si fuera igual no se renderizaría porque no detecta un cambio en el estado)

    if (!ultimoRegistro){ // si no hay un registro de la hora de actividad significa que es la primera vez que se monta esta vista entonces inicializamos la hora actual y luego seguimos monitoreando los clicks
        sessionStorage.setItem('haction',fechaActual())
    }else{
      diferencia = compararFechas(ultimoRegistro) // comparamos la hora actual con la última hora registrada de actividad del usuario


      if (diferencia>tiempo_en_segundos_inactividad && !checking ){ // si la diferencia de tiempo es de 3 minutos y aún no hemos mostrado el mensaje al usuario iniciamos el procedimiento para mostrar el mensaje pidiendo al usuario que confirme que sigue conectado y activando los timers de reinicio
       contador = 100; // es la variable que usamos para mostrar al usurio el tiempo que falta para que termine su sesión por inactividad 

       //sessionStorage.removeItem('haction')
       sessionStorage.setItem('checking',true) // marcamos el flag para evitar que se vuelva a hacer todo N veces o sea para asegurarnos que se haga 1 sola vez cada vez que se detecta la inactividad
       
       setTimeout(() => {
          mostrarTimer() // iniciamos el contador de fin de sesión, pero en 500 milisegundos para asegurarnos que el elemento con id "mensaje_fin_sesion" ya exista en el DOM, necesitamos esperar un poco porque todavía no existe, se crea en el html del sweat alert
       }, 500);

        id_tiempo_reinicio = setTimeout(() => { // una vez que detectamos la inactividad de N minutos y mostramos el mensaje al usuario activamos un timer de 100 segundos, es decir en 100 segundo se va a ejecutar el fin de la sesión si no confirma que sigue conectado 
            
            // si el usurio no confirmo que sigue conectado eliminamos el token que le permitía acceder a los recursos del servidor
            // forzamos el renderizado de la vista al cambiar el estado modificando la propiedad reinicioLogin con la funcion setRenicioLogin
            // también eliminamos el flag para que no persista y se pueda volver a iniciar el ciclo de monitoreo
            // limpiamos el intervalo que hacia de timer
            sessionStorage.removeItem('REG_TOKEN')
            sessionStorage.removeItem('checking')
            clearInterval(id_intervalo_contador)
            clearInterval(id_intervalo_monitoreo)
            setReinicioLogin()
          }, 100000);

        // Mostramos la ventana al usuario para que confirme si sigue conectado
        // es importante que haya en el html del mensaje el elemento con id mensaje_fin_sesion para que se muestre el timer con el contador de fin de sesión
        Swal.fire({
          html:'<h3>¿Sigues conectado?</h3><p id="mensaje_fin_sesion"></p>',
          confirmButtonText:'Si, sigo conectado',
          allowOutsideClick: false
      }).then(
          resultado=>{
              if (resultado.value){

                 // si el usuario confirma que sigue conectado limpiamos los flags para reiniciar el monitoreo hasta detectar otro tiempo de inactividad y volver a disparar el proceso de confirmación
                 sessionStorage.removeItem('haction') // lo limpio para reiniciar la hora de última actividad y comenzar de nuevo desde la hora actual
                 sessionStorage.removeItem('checking') // lo limpio para que no persista y se pueda volver a disparar el proceso de confirmación de actividad, si no se limpiara no entraría otra vez
                 clearInterval(id_intervalo_contador) // lo limpio para que deje de contar hacia atrás
                 clearTimeout(id_tiempo_reinicio) // lo limpio para detener el proceso de finalización de la sesión
              }
          }
      )
      }
    }
} 

function mostrarTimer(){
    let texto = document.getElementById("mensaje_fin_sesion")

    // busco en el DOM el elemento con id mensaje_fin_sesion que se creó en el html del mensaje con sweatalert
    // y luego cada 1 segundo resto 1 del contador hasta el fin de la sesión

    id_intervalo_contador = setInterval(() => {
        contador = contador - 1;
        texto.innerHTML= `La sesión terminará en  ${contador}`
    }, 1000);
}

function confirmarTiempoInactividadAceptado(){
// uso esta funcion para modificar el tiempo de inactividad (en segundos) que se tomamos como
// parametro para pedir la confirmación al usuario que sigue conectado. Por default es 180 segundos pero
// en testing lo puedo llegar a modificar para algún tipo de prueba
// Si en la clave tcustom del localstorage hay un número lo va a tomar para reemplazar la variable tiempo_en_segundos_inactividad
// si no existe o no es un número toma el que ya estaba asignado en la declaración de la variable

    const existe_tcustom = localStorage.getItem('tcustom')
    if (existe_tcustom  ){

        const prueba_numero = Number(existe_tcustom)
        
        if (typeof(prueba_numero)==='number'){
            tiempo_en_segundos_inactividad = prueba_numero;
        }
    }
}

function conectarWebSocket(){
    const connectionOptions =  {
      "force new connection" : true,
      "reconnectionAttempts": "Infinity", 
      "timeout" : 10000,                  
      "transports" :  ["websocket"]
    };
    
    // me conecto al servidor websockets
    let url = window.location.href;
    const {hostname} = new URL(url);

//en desarrollo
   return socketIOClient.connect(`http://${hostname}:4002`,connectionOptions)

//en producción
   return socketIOClient.connect(`https://${hostname}`,connectionOptions)

  }

  const procesarRespuesta = (setError,err)=>{
     if (err.response?.data) {
      const { code, message } = err.response.data;

      switch (code) {
        case 'INVALID_CREDENTIALS':
          setError('Los datos ingresados no son correctos. Por favor verifique su usuario y contraseña.');
          break;
        case 'RATE_LIMIT_EXCEEDED':
          setError('Demasiados intentos. Por favor, espere unos minutos y vuelva a intentarlo.');
          break;
        case 'CAPTCHA_INVALIDO':
          setError('La validación de seguridad falló. Por favor intente nuevamente.');
          break;
        default:
          setError(message || 'Error al intentar ingresar.');
      }
    } else {
      setError('No es posible conectar con el servidor.');
    }
  
    // if(err.response.status==500){
    //   console.log(err)
    //   setError('Se produjo un error en el servidor. Intente más tarde o contacte al personal administrativo')
    // }else if (err.response.status==404){
    //     console.log(err)
    //     setError('Se produjo un error de autorización. Contacte al personal administrativo')
    // }else{
    //     if (err.response.data.message){
    //       console.log(JSON.stringify(err.response.data.message))
    //       setError(err.response.data.message)
    //     }else{
    //       setError('Se produjo un error en el acceso al sistema. Contacte al personal administrativo')
    //     }
    // }
  }